export default {
    title: 'Fila de Atendimento',
    open_services: 'Atendimentos em Aberto',
    realized_services: 'Atendimentos Finalizados',
    position: 'º na fila',
    realize: {
        success: 'Atendimento finalizado com sucesso.',
        error: 'Ocorreu um erro ao tentar salvar a finalização do atendimento.'
    },
    filter: {
        title: 'Filtro',
        company: 'Empresa',
        unit_care: 'Unidade de Atendimento',
        sector: 'Setor',
        filter_button: 'Filtrar',
        clear_button: 'Limpar Filtros'
    },
    caption: {
        title: 'Legenda',
        service: 'Legenda de Atendimento',
        service_queue: 'Fila de Atendimento',
        service_waiting: 'Aguardando Atendimento',
        realized_service: 'Atendimento Finalizado',
        report_not_send: 'O Resultado ainda não foi enviado',
        report_sended: 'O Resultado foi enviado',
    }
}
